import React, { useState } from 'react';
import { Form, Button, Row, Col } from 'react-bootstrap';
import useFetchWithMsal from '../hooks/useFetchWithMsal';
import { protectedResources, scopes } from "../authConfig";
import ForeignTableSelect from '../components/utils/ForeignTableSelect';
import { FaSave, FaTimes } from 'react-icons/fa';

function UserEditForm({ user, onDone }) {
    const { execute } = useFetchWithMsal({
        scopes: scopes.callapi
    });
    const [formData, setFormData] = useState({
        id: user.id || "",
        displayName: user.displayName || "",
        companyId: user.CompanyId || "",
        permissionType: user.PermissionType || "1",
        surname: user.surname || "",
        givenName: user.givenName || "",
        loginName: user.loginName || "",
        accountEnabled: user.accountEnabled || false,
    });

    // 初期値のuser.idがundefinedでない場合は更新処理
    const isUpdate = user.id !== undefined;

    const handleChange = (event) => {
        let value;
        if (event.target.type === 'checkbox') {
            value = event.target.checked;
        } else if (event.target.type === 'select-multiple') {
            value = Array.from(event.target.selectedOptions).map(option => option.value);
        } else if (event.target.type === 'select-one') {
            value = event.target.selectedOptions[0].value;
        }
        else {
            value = event.target.value;
        }

        setFormData({
            ...formData,
            [event.target.name]: value,
        });
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        console.log("call handleSubmit");
        const user = {
            id: formData.id,
            displayName: formData.displayName,
            CompanyId: formData.companyId,
            PermissionType: Number(formData.permissionType),
            surname: formData.surname,
            givenName: formData.givenName,
            password: formData.password,
            loginName: formData.loginName,
            accountEnabled: formData.accountEnabled,
        };

        // 登録の場合はパスワードのバリデーションを行う
        if (!isUpdate) {
            const password = formData.password
            const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,}$/;
            if (!password.match(passwordRegex)) {
                alert('パスワードは大文字、小文字、数字をそれぞれ1文字以上含む8文字以上で設定してください');
                return;
            }
        }

        if (isUpdate === false) {
            console.log("call create");
            const response = execute("POST", protectedResources.createUser.endpoint, user);
            console.log("response" + response);
        } else {
            console.log("call update");
            const response = execute("PUT", protectedResources.updateUser.endpoint, user);
            console.log("response" + response);
        }
        onDone();
    };

    return (
        <Form onSubmit={handleSubmit}>
            <Row className="g-3">
                {isUpdate && (
                    <Col md={6}>
                        <Form.Group>
                            <Form.Label className="fw-medium">ID</Form.Label>
                            <Form.Control 
                                type="text" 
                                name="id" 
                                value={formData.id} 
                                onChange={handleChange} 
                                disabled 
                                className="bg-light"
                            />
                        </Form.Group>
                    </Col>
                )}
                <Col md={6}>
                    <Form.Group>
                        <Form.Label className="fw-medium">ログイン名（メールアドレス）</Form.Label>
                        <Form.Control 
                            type="email" 
                            name="loginName" 
                            value={formData.loginName} 
                            onChange={handleChange} 
                            className="border-secondary-subtle"
                            placeholder="example@example.com"
                        />
                    </Form.Group>
                </Col>
                <Col md={6}>
                    <Form.Group>
                        <Form.Label className="fw-medium">表示名</Form.Label>
                        <Form.Control 
                            type="text" 
                            name="displayName" 
                            value={formData.displayName} 
                            onChange={handleChange} 
                            className="border-secondary-subtle"
                            placeholder="表示される名前"
                        />
                    </Form.Group>
                </Col>
                <Col md={6}>
                    <Form.Group>
                        <Form.Label className="fw-medium">会社名</Form.Label>
                        <ForeignTableSelect 
                            type="company" 
                            displayName="会社" 
                            value={formData.companyId} 
                            onChange={handleChange} 
                        />
                    </Form.Group>
                </Col>
                <Col md={6}>
                    <Form.Group>
                        <Form.Label className="fw-medium">権限</Form.Label>
                        <Form.Select 
                            name="permissionType" 
                            value={formData.permissionType} 
                            onChange={handleChange}
                            className="border-secondary-subtle"
                        >
                            <option value="1">一般ユーザー</option>
                            <option value="2">事務局</option>
                            <option value="3">人事</option>
                            <option value="4">管理者</option>
                        </Form.Select>
                    </Form.Group>
                </Col>
                <Col md={6}>
                    <Form.Group>
                        <Form.Label className="fw-medium">姓</Form.Label>
                        <Form.Control 
                            type="text" 
                            name="surname" 
                            value={formData.surname} 
                            onChange={handleChange} 
                            className="border-secondary-subtle"
                            placeholder="姓"
                        />
                    </Form.Group>
                </Col>
                <Col md={6}>
                    <Form.Group>
                        <Form.Label className="fw-medium">名</Form.Label>
                        <Form.Control 
                            type="text" 
                            name="givenName" 
                            value={formData.givenName} 
                            onChange={handleChange} 
                            className="border-secondary-subtle"
                            placeholder="名"
                        />
                    </Form.Group>
                </Col>
                <Col md={6}>
                    <Form.Group className="d-flex flex-column h-100">
                        <Form.Label className="fw-medium mb-2">アカウント状態</Form.Label>
                        <div className="d-flex align-items-center h-100 pt-2">
                            <Form.Check 
                                type="switch"
                                id="account-status-switch"
                                name="accountEnabled" 
                                label={formData.accountEnabled ? "有効" : "無効"}
                                checked={formData.accountEnabled} 
                                onChange={handleChange}
                                className="fs-6"
                            />
                        </div>
                    </Form.Group>
                </Col>
                {!isUpdate && (
                    <Col md={12}>
                        <Form.Group>
                            <Form.Label className="fw-medium">パスワード</Form.Label>
                            <Form.Control 
                                type="password" 
                                name="password" 
                                value={formData.password || ''} 
                                onChange={handleChange}
                                className="border-secondary-subtle"
                                placeholder="8文字以上（大文字・小文字・数字を含む）"
                            />
                            <Form.Text className="text-muted">
                                パスワードは大文字、小文字、数字をそれぞれ1文字以上含む8文字以上で設定してください
                            </Form.Text>
                        </Form.Group>
                    </Col>
                )}
            </Row>
            
            <div className="d-flex justify-content-end gap-2 mt-4">
                <Button 
                    variant="outline-secondary" 
                    onClick={onDone}
                    className="d-flex align-items-center gap-1"
                >
                    <FaTimes /> キャンセル
                </Button>
                <Button 
                    variant="primary" 
                    type="submit"
                    className="d-flex align-items-center gap-1 px-4"
                >
                    <FaSave /> 保存
                </Button>
            </div>
        </Form>
    );
}

export default UserEditForm;